/**
 * 席の iPhone の電池と熱（Issue #780）。iPhone は補正サーバーへ直通で、/state に battery（0〜1）と thermal を載せる
 * （tethercam #13）。補正サーバーの /live/cams.json の devices に出るので、それを読んで「席 1: 電池 62% / 熱 fair」と出す。
 * 給電できない置き方があるので撮影の画面から見えるように。補正サーバーが寝ていれば何も出さない。
 */
import { liveUrl } from './liveBase';
import { useEffect, useState } from 'react';

const THERMAL = { nominal: '平常', fair: 'やや熱い', serious: '熱い', critical: '危険' };
export const STALE_SEC = 30;

/** 1 台の一言（devices の値）。古ければ null */
export function deviceText(d) {
  if (!d || (d.age_sec != null && d.age_sec > STALE_SEC)) return null;
  const parts = [];
  if (typeof d.battery === 'number') parts.push(`電池 ${Math.round(d.battery * 100)}%`);
  if (d.thermal) parts.push(`熱 ${THERMAL[d.thermal] ?? d.thermal}`);
  return parts.length ? parts.join(' / ') : null;
}

/** 注意が要るか（電池 20% 未満・熱が serious 以上） */
export function deviceWarn(d) {
  return !!d && ((typeof d.battery === 'number' && d.battery < 0.2) || d.thermal === 'serious' || d.thermal === 'critical');
}

export default function LiveDevicesPanel({ fetchImpl = null, intervalMs = 5000 }) {
  const [devices, setDevices] = useState(null);
  useEffect(() => {
    const f = fetchImpl ?? (typeof fetch === 'function' && !navigator.userAgent.includes('jsdom') ? fetch : null);
    if (!f) return undefined;
    let alive = true;
    let timer;
    const poll = async () => {
      let next = null;
      try {
        const r = await f(liveUrl('/live/cams.json'), { cache: 'no-store' });
        next = r.ok ? (await r.json())?.devices ?? null : null;
      } catch { next = null; }
      if (!alive) return;
      setDevices(next);
      timer = setTimeout(poll, intervalMs);
    };
    poll();
    return () => { alive = false; clearTimeout(timer); };
  }, [fetchImpl, intervalMs]);

  const rows = ['seat1', 'seat2'].map((k) => [k, devices?.[k]]).filter(([, d]) => deviceText(d));
  if (!rows.length) return null;
  return (
    <section className="card" data-testid="live-devices" style={{ display: 'flex', gap: 16, flexWrap: 'wrap', fontSize: 14 }}>
      {rows.map(([k, d]) => (
        <span key={k} data-testid={`live-device-${k}`} style={{ color: deviceWarn(d) ? '#ff8a8a' : undefined }}>
          席 {k.slice(4)}: {deviceText(d)}
        </span>
      ))}
    </section>
  );
}
